import { useEffect, useRef } from "react";
import {
  useAudioVideo,
  useContentShareState,
} from "amazon-chime-sdk-component-library-react";
import { VideoUITileContentShare } from "./VideoUITileContentShare";

export function VideoUITileContentShareContainer() {
  const audioVideo = useAudioVideo();

  const { tileId, isLocalUserSharing, sharingAttendeeId } = useContentShareState();

  const videoEl = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (!audioVideo || !videoEl.current || !tileId) {
      return;
    }

    audioVideo.bindVideoElement(tileId, videoEl.current);

    return () => {
      const tile = audioVideo.getVideoTile(tileId);
      if (tile) {
        audioVideo.unbindVideoElement(tileId);
      }
    };
  }, [audioVideo, tileId]);

  const isContentSharing = isLocalUserSharing || !!sharingAttendeeId;

  return tileId ? <VideoUITileContentShare ref={videoEl} isContentSharing={isContentSharing} /> : null;
}

export default VideoUITileContentShareContainer;
